export const MAX_COMMUNITY_TAG_COUNT = 5;
export const MAX_COMMUNITY_TAG_LENGTH = 20;

const COMMUNITY_TAG_ALLOWED_REGEX = /^[0-9A-Za-z가-힣ㄱ-ㅎㅏ-ㅣ_]{1,20}$/;

export const normalizeCommunityTagName = (tag: string) => {
  return tag.trim().replace(/^#+/, '').slice(0, MAX_COMMUNITY_TAG_LENGTH);
};

export const isValidCommunityTagName = (tag: string) => {
  return COMMUNITY_TAG_ALLOWED_REGEX.test(tag);
};

export const getCommunityTagNamesWithInput = (
  tags: string[],
  inputValue: string
) => {
  const normalizedTag = normalizeCommunityTagName(inputValue);

  if (
    tags.length >= MAX_COMMUNITY_TAG_COUNT ||
    !isValidCommunityTagName(normalizedTag) ||
    tags.includes(normalizedTag)
  ) {
    return tags;
  }

  return [...tags, normalizedTag];
};

export const getAvailableCommunityTagRecommendations = (
  tags: string[],
  inputValue: string,
  recommendedTagNames: string[]
) => {
  const tagsWithInput = getCommunityTagNamesWithInput(tags, inputValue);
  const remainingCount = MAX_COMMUNITY_TAG_COUNT - tagsWithInput.length;

  if (remainingCount <= 0) {
    return [];
  }

  return recommendedTagNames.reduce<string[]>((availableTags, tagName) => {
    if (availableTags.length >= remainingCount) {
      return availableTags;
    }

    const normalizedTag = normalizeCommunityTagName(tagName);
    if (
      !isValidCommunityTagName(normalizedTag) ||
      tagsWithInput.includes(normalizedTag) ||
      availableTags.includes(normalizedTag)
    ) {
      return availableTags;
    }

    return [...availableTags, normalizedTag];
  }, []);
};

export const getCommunityTagNamesFromTags = (
  tags?: { name: string }[] | null
) => {
  return tags?.map((tag) => tag.name).filter(Boolean) ?? [];
};
